import React, { useEffect } from "react";

import "./style.scss";

interface Props {
  style?: React.CSSProperties;
  children?: React.ReactNode;
}

const Body = (props: Props) => {
  const { style = {}, children = <></> } = props;

  useEffect(() => {}, []);

  return (
    <div style={style} className="good_use-body">
      {children}
    </div>
  );
};

export default Body;
